import { render } from "./MessagesPage.vue?vue&type=template&id=93a4c3a2&ts=true"
import script from "./MessagesPage.vue?vue&type=script&lang=ts"
export * from "./MessagesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Messages/MessagesPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "93a4c3a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('93a4c3a2', __exports__)) {
    api.reload('93a4c3a2', __exports__)
  }
  
  module.hot.accept("./MessagesPage.vue?vue&type=template&id=93a4c3a2&ts=true", () => {
    api.rerender('93a4c3a2', render)
  })

}


export default __exports__